import {AlertTriangleIcon, MessageIcon} from './icons';
import {NoteTag} from './ui-components';
import Text from '@/components/react-native/text';
import TouchableOpacity from '@/components/react-native/touchable-opacity';
import View from '@/components/react-native/view';
import {airportNotePublishedFormatted} from '@/services/community';
import {ENoteTag} from '@/types/airport';
import React from 'react';

interface NoteItemProps {
  tags: ENoteTag[];
  category: string;
  content: string;
  author: string;
  publishedAt: string;
  commentCount?: number;
  isNew?: boolean;
  isPending?: boolean;
  showEdit?: boolean;
  onPress?: () => void;
  onEdit?: () => void;
}

export const NoteItem = React.memo(
  ({
    tags,
    category,
    content,
    author,
    publishedAt,
    commentCount = 0,
    isNew = false,
    isPending = false,
    showEdit = false,
    onPress,
    onEdit
  }: NoteItemProps) => {
    const hasComments = commentCount > 0;

    return (
      <TouchableOpacity
        onClick={onPress}
        className="py-[16px]"
        activeOpacity={0.7}
      >
        {isPending && (
          <View className="flex-row items-center gap-[4px] px-[16px] mb-[8px]">
            <AlertTriangleIcon />
            <Text
              fontFamily="Geist"
              className="text-[#EB8200] text-[14px] font-[500]"
            >
              Community contribution pending admin review. Use with caution.
            </Text>
          </View>
        )}

        <View className="px-[16px]">
          <View className="flex-row items-start gap-[6px] mb-[16px]">
            <View className="flex-1">
              <Text
                fontFamily="Geist"
                className="text-[#E7E5E4] text-[16px] font-[500] tracking-[-0.32px] leading-[24px]"
              >
                {content}
              </Text>
            </View>
          </View>

          <View className="flex-row items-center justify-between">
            <View className="flex-row items-center gap-[16px]">
              <View
                className={`flex-row items-center gap-[2px] px-[8px] py-[4px] rounded-[9999px] ${
                  hasComments ? 'bg-[rgba(56,189,248,0.2)]' : ''
                }`}
              >
                <MessageIcon hasComments={hasComments} />
                <Text
                  fontFamily="Geist"
                  className={`text-[14px] font-[500] ${
                    hasComments ? 'text-[#38BDF8]' : 'text-[#A8A29E]'
                  }`}
                >
                  {hasComments ? commentCount.toString() : '0'}
                </Text>
              </View>

              <Text
                fontFamily="Geist"
                className="text-[#78716C] text-[14px] font-[400] tracking-[-0.28px]"
              >
                {airportNotePublishedFormatted(publishedAt, isPending, author)}
              </Text>
            </View>

            {showEdit && onEdit && (
              <TouchableOpacity className="px-[16px] py-[8px]" onClick={onEdit}>
                <Text
                  fontFamily="Geist"
                  className="text-[#38BDF8] text-[16px] font-[500] tracking-[-0.32px]"
                >
                  Edit
                </Text>
              </TouchableOpacity>
            )}
            {isPending && (
              <TouchableOpacity
                onPress={onPress}
                className="bg-[#38BDF8] rounded-[6px] px-[14px] py-[12px] mr-[16px]"
              >
                <Text
                  fontFamily="Geist"
                  className="text-[#1C1917] text-[16px] font-[500] leading-[20px]"
                >
                  Review
                </Text>
              </TouchableOpacity>
            )}
          </View>
        </View>
      </TouchableOpacity>
    );
  }
);
NoteItem.displayName = 'NoteItem';
